







import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { HotChapterService } from '../../api/hotChapter';

@Component({})
export default class HotChapter extends Vue {
  @Prop() private literatureId?: string;
  private service: HotChapterService = new HotChapterService();
  private data: any[] = [];
  @Watch('literatureId')
  private literatureId_OnChange(val: any, oldVal: any) {
    this.loadData(val);
  }

  private mounted() {
    if (this.literatureId !== null && this.literatureId !== undefined && this.literatureId !== '') {
      this.loadData(this.literatureId);
    }
  }
  private loadData(id: string) {
    this.service.GetHotChapter(id, 10).then((response: any) => {
      let content!: any;
      for (const item of response) {
        content = document.getElementById(item.chapterID);
        if (content !== undefined) {
          item.content = content.outerText;
        }
      }
      this.data = response;
    });
  }

}
